module.exports = __webpack_public_path__ + "static/media/evidency2.efae9bad.svg";